<div class="observations-page trade-page">
  <div class="page-header">
    <app-page-title description="รายการแจ้งเตือนข้อสังเกตในห่วงโซ่อุปทาน สำหรับเจ้าหน้าที่ตรวจสอบความถูกต้อง"></app-page-title>
  </div>

  <div class="observation-summary">
    @for (type of types; track type) {
      <button type="button" class="summary-card"
              [class.is-active]="typeFilter() === type"
              [attr.data-type]="type"
              (click)="setType(type)">
        <div class="summary-card-body">
          <div class="summary-card-header">
            <span class="summary-card-title">{{ typeLabel(type) }}</span>
            <span class="summary-status-dot" [class]="'dot-' + type"></span>
          </div>

          <div class="summary-icon-box" [class]="'icon-box-' + type">
            @if (type === 'NO_ACFS_CERTIFICATE') {
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-alert"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
            } @else if (type === 'STARTED_MID_CHAIN') {
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-git-branch"><line x1="6" x2="6" y1="3" y2="15"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 0 1-9 9"/></svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-merge"><path d="m8 6 4-4 4 4"/><path d="M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22"/><path d="m20 22-5-5"/></svg>
            }
          </div>

          <div class="summary-metric-box">
            <span class="summary-metric-label">จำนวนข้อสังเกต</span>
            <div class="summary-metric-value">
              <span class="summary-count">{{ countByType()[type].toLocaleString('th-TH') }}</span>
              <span class="summary-unit">รายการ</span>
            </div>
          </div>
        </div>
      </button>
    }
  </div>

  <div class="listing-card">
    <div class="listing-card-header">
      <div class="header-main-row">
        <h6 class="section-title mb-0">รายการข้อสังเกตที่ตรวจพบ</h6>
        <div class="header-actions">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="reload()" [disabled]="loading()">
            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i> รีเฟรชข้อมูล
          </button>
        </div>
      </div>

      <div class="header-toolbar-row">
        <div class="filter-search-wrap">
          <i class="bi bi-search filter-search-icon" aria-hidden="true"></i>
          <label class="visually-hidden" for="obs-search">ค้นหา</label>
          <input id="obs-search" type="search" class="form-control filter-search-input"
                 placeholder="ค้นหาชื่อสินค้า, รหัสบันทึก, ชื่อฟาร์ม หรือธุรกิจ..."
                 [value]="search()" (input)="onSearch($event)">
        </div>

        <div class="kind-filter-wrap ms-auto">
          @if (productOptions().length > 0) {
            <label class="visually-hidden" for="obs-product">สินค้า</label>
            <select id="obs-product" class="form-select form-select-sm" [value]="selectedProduct()"
                    (change)="onProductChange($event)">
              <option value="">สินค้าทั้งหมด</option>
              @for (name of productOptions(); track name) {
                <option [value]="name">{{ name }}</option>
              }
            </select>
          }
          <label class="visually-hidden" for="obs-page-size">จำนวนต่อหน้า</label>
          <select id="obs-page-size" class="form-select form-select-sm" [value]="pageSize()"
                  (change)="onPageSizeChange($event)">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }} รายการ / หน้า</option>
            }
          </select>
        </div>
      </div>
    </div>

    <!-- Role-style status filter bar for observation types -->
    <div class="role-tabs-bar" aria-label="กรองประเภทข้อสังเกต">
      <button type="button"
              class="role-tab"
              [class.active]="typeFilter() === null"
              (click)="setType(null)">
        ทั้งหมด
        @if (items().length > 0) {
          <span class="tab-count">{{ items().length }}</span>
        }
      </button>
      @for (type of types; track type) {
        <button type="button"
                class="role-tab"
                [class.active]="typeFilter() === type"
                (click)="setType(type)">
          {{ typeShortLabel(type) }}
          @if (countByType()[type] > 0) {
            <span class="tab-count">{{ countByType()[type] }}</span>
          }
        </button>
      }
    </div>

    <div class="result-line">
      พบ {{ filtered().length.toLocaleString('th-TH') }} รายการ
    </div>

    @if (loading()) {
      <div class="d-flex justify-content-center align-items-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">กำลังโหลด…</span>
        </div>
      </div>
    } @else if (filtered().length === 0) {
      <div class="record-empty-state">
        <i class="bi bi-shield-check empty-state-icon text-success" aria-hidden="true"></i>
        <strong>ไม่พบข้อมูลข้อสังเกต</strong>
        <span>บันทึกการซื้อ-ขายและเส้นทางสินค้าเป็นไปตามเกณฑ์ปกติ</span>
      </div>
    } @else {
      <!-- ตาราง Desktop / จอกลางขึ้นไป -->
      <div class="d-none d-md-block table-responsive record-table-shell">
        <table class="table table-hover align-middle mb-0 record-table">
          <thead class="table-light text-secondary">
            <tr>
              <th scope="col" style="width: 52px;">#</th>
              <th scope="col" class="ps-3">สินค้า</th>
              <th scope="col">รหัสรายการ / วันที่</th>
              <th scope="col">สถานประกอบการ / ผู้บันทึก</th>
              <th scope="col" style="min-width: 280px;">ประเภทข้อสังเกตและรายละเอียด</th>
              <th scope="col" class="text-end">ปริมาณรวม</th>
              <th scope="col" class="text-start pe-3" style="width: 120px;">การจัดการ</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems(); track item.recordId + '|' + item.type + '|' + $index; let i = $index) {
              <tr class="trade-row">
                <td class="text-muted">{{ itemRowNumber(i).toLocaleString('th-TH') }}</td>
                <td class="record-product-cell ps-3">
                  <div class="d-flex align-items-center gap-2">
                    <div class="record-thumb">
                      <app-fruit-icon class="table-fruit-icon" [product]="item.productName || ''"></app-fruit-icon>
                    </div>
                    <div class="min-w-0">
                      <span class="record-product-name">{{ item.productName || 'ไม่ระบุสินค้า' }}</span>
                      @if (item.kind) {
                        <span class="record-product-meta">
                          <span class="sub">{{ tradeRecordLabel(item) }}</span>
                        </span>
                      }
                    </div>
                  </div>
                </td>
                <td>
                  @if (item.recordCode) {
                    <app-record-code [code]="item.recordCode"/>
                  }
                  <span class="sub">{{ (item.recordedAt | thaidatetime) || '-' }}</span>
                </td>
                <td>
                  <div class="fw-semibold text-dark">{{ item.businessTitle || '—' }}</div>
                  @if (item.ownerName) {
                    <span class="sub">{{ item.ownerName }}</span>
                  }
                </td>
                <td>
                  <span [class]="'badge ' + typeBadge(item.type)">{{ typeLabel(item.type) }}</span>
                  <div class="small text-secondary observation-message mt-1">{{ item.message }}</div>
                  @if (item.relatedRecordIds?.length) {
                    <div class="small mt-1 text-secondary">
                      ล็อตต้นทางที่เกี่ยวข้อง:
                      @for (id of item.relatedRecordIds; track id) {
                        <a [routerLink]="[tradeBase, id]" class="fw-semibold text-primary text-decoration-none me-1">#{{ id }}</a>
                      }
                    </div>
                  }
                  @if (item.selfKeyedCertificateNos?.length) {
                    <div class="small mt-1 text-muted">
                      ใบรับรองที่กรอกเอง: {{ item.selfKeyedCertificateNos.join(', ') }}
                    </div>
                  }
                </td>
                <td class="text-end text-nowrap">
                  <span class="fw-semibold">{{ formatQuantityWithUnit(item.quantity, item.unit) }}</span>
                  @if (item.relatedQuantity) {
                    <div class="small text-muted">
                      (ปน {{ formatQuantityWithUnit(item.relatedQuantity, item.unit) }})
                    </div>
                  }
                </td>
                <td class="text-start pe-3">
                  <a class="btn btn-sm btn-action-pill text-decoration-none" [routerLink]="[tradeBase, item.recordId]">
                    <i class="bi bi-diagram-3" aria-hidden="true"></i>
                    <span>ดูเส้นทาง</span>
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- การ์ด Mobile (จอเล็ก) -->
      <div class="d-md-none record-mobile-list">
        @for (item of pagedItems(); track item.recordId + '|' + item.type + '|' + $index) {
          <div class="card record-card mb-3 border">
            <div class="card-body p-3">
              <div class="d-flex align-items-start gap-3">
                <div class="record-thumb flex-shrink-0">
                  <app-fruit-icon class="table-fruit-icon" [product]="item.productName || ''"></app-fruit-icon>
                </div>
                <div class="flex-grow-1 min-w-0">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
                    <h6 class="mb-0 fw-semibold text-truncate">{{ item.productName || 'ไม่ระบุสินค้า' }}</h6>
                    <span [class]="'badge ' + typeBadge(item.type)">{{ typeShortLabel(item.type) }}</span>
                  </div>

                  <div class="small text-secondary mb-1">
                    <i class="bi bi-shop me-1"></i>
                    <strong class="text-dark">{{ item.businessTitle || '—' }}</strong>
                    @if (item.ownerName) {
                      <span class="ms-1">({{ item.ownerName }})</span>
                    }
                  </div>

                  <p class="mb-1 text-muted small">
                    <i class="bi bi-calendar3 me-1"></i>
                    {{ (item.recordedAt | thaidatetime) || '-' }}
                    @if (item.kind) {
                      · <span class="text-secondary">{{ tradeRecordLabel(item) }}</span>
                    }
                  </p>

                  <div class="alert alert-light border small py-2 px-2 mb-2">
                    <div class="fw-semibold text-dark mb-1">{{ typeLabel(item.type) }}</div>
                    <div class="text-secondary">{{ item.message }}</div>
                    @if (item.relatedRecordIds?.length) {
                      <div class="mt-1">
                        ล็อตต้นทางที่เกี่ยวข้อง:
                        @for (id of item.relatedRecordIds; track id) {
                          <a [routerLink]="[tradeBase, id]" class="fw-semibold me-1">#{{ id }}</a>
                        }
                      </div>
                    }
                  </div>

                  <div class="d-flex align-items-center justify-content-between gap-2 pt-2 border-top">
                    <div>
                      @if (item.recordCode) {
                        <app-record-code [code]="item.recordCode"/>
                      }
                      <span class="small text-muted ms-1">{{ formatQuantityWithUnit(item.quantity, item.unit) }}</span>
                    </div>

                    <a class="btn btn-sm btn-action-pill text-decoration-none" [routerLink]="[tradeBase, item.recordId]">
                      <i class="bi bi-diagram-3" aria-hidden="true"></i>
                      <span>ดูเส้นทาง</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Pagination -->
      @if (totalPages() > 1) {
        <div class="pagination-row">
          <ngb-pagination [collectionSize]="filtered().length" [page]="page()"
                          [pageSize]="pageSize()" [maxSize]="7" [boundaryLinks]="true"
                          [rotate]="true" size="sm" (pageChange)="setPage($event)"/>
          <span class="page-hint">หน้า {{ page().toLocaleString('th-TH') }} / {{ totalPages().toLocaleString('th-TH') }}</span>
        </div>
      }
    }
  </div>
</div>
